/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSubsetTransform } from '../../factoriesAny.js';
export var subsetTransformDependencies = {
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createSubsetTransform: createSubsetTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSubsetTransform.generated.js
// module id = 1665
// module chunks = 0